import { ActivationState } from '@stomp/stompjs';
import type { InternalChatConversation } from 'packages/workspace/services/models/internal-channel';
import useInternalConversationStore from 'packages/workspace/services/store/omnichannel/internal-conversation-store';
import useSession from 'packages/workspace/services/store/session-store';
import { useEffect, useState } from 'react';
import { InternalMessageComponent } from './InternalMessageComponent';

export const InternalMessageContainer: React.FC = () => {
  const [activeConversation, SetActiveConversation] = useState<InternalChatConversation | undefined>(undefined);
  const session = useSession();
  const internalConvState = useInternalConversationStore();

  useEffect(() => {
    SetActiveConversation(internalConvState.active_conversations.find((eachConversartion) => eachConversartion.conversation_id === internalConvState.active_window?.conversation_id));
  }, [internalConvState.active_window]);

  return (
    <>
      {activeConversation && internalConvState.client.state === ActivationState.ACTIVE ? (
        <InternalMessageComponent
          conversation_id={activeConversation?.conversation_id}
          user_id={session.iamPrincipal.id}
          user_name={session.iamPrincipal.displayName}
          display_name={activeConversation?.display_name}
          conversation_messages={internalConvState.ongoing_messages[activeConversation?.conversation_id]}
        />
      ) : (
        <div className="h-full items-center justify-items-center pt-10 text-center">
          <span className="font-bold"> Please Select Any Conversation from the Left</span>
        </div>
      )}
    </>
  );
};
